import type { QueryHookOptions } from "@apollo/client"
import { useQuery } from "@apollo/client"
import query from "@/v2-backoffice-client/usage/mcp/usage.mcpUser.query.gql"
import type {
  UsageMcpUserQuery,
  UsageMcpUserQueryVariables,
} from "@/v2-backoffice-client/usage/mcp/__types__/usage.mcpUser.query"

type Options = QueryHookOptions<UsageMcpUserQuery, UsageMcpUserQueryVariables>

export function useUsageMcpUserQuery(options?: Options) {
  return useQuery<UsageMcpUserQuery, UsageMcpUserQueryVariables>(query, options)
}
